<template>
  <div class="top">
    <div class="addr">
      <i class="iconfont iconaddress1"></i>
      <div class="city" v-on:click="$router.push('/community/community')">
        <span>{{community.name}}</span>
        <i class="iconfont iconxiala"></i>
      </div>
      <!-- <div class="city" v-on:click="goCity()">
        <span>{{city.area_name}}</span>
        <i class="iconfont iconxiala"></i>
      </div> -->
    </div>
    <div class="search">
      <van-search v-model="keywords" placeholder="请输入搜索关键词" @search="onSearch" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Search } from "vant";

Vue.use(Search);
export default {
  name: "top",
  data() {
    return {
      keywords: "",
      city: { area_id: 2, area_name: "北京市" },
      community:{name:'授权获取位置'}
    };
  },
  methods: {
    goCity() {
      this.$router.push("/city");
    },
    onSearch(val){
        this.$router.push('/shop/list/0/'+val);

    }
  },
  mounted() {
    if (localStorage.getItem("city")) {
      this.city = JSON.parse(localStorage.getItem("city"));
    }
    if(localStorage.getItem('community')){
        this.community = JSON.parse(localStorage.getItem('community'));
    }
  }
};
</script>
<style lang="scss" scoped>
.top {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  //color: #1baeae;
  //background-color: #fe7563;
  //background-color:#ba1f21;
  //background: linear-gradient(to right,#780001,#d3512f,#780001);
  //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
  //background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
  .addr {
    padding: 15px 0 15px 12px;
    display: flex;
    background-color: #fff;
    // background-color:#fe7563;
    //background-color:#ba1f21;
     //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
     background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
     //background: linear-gradient(to right,#c02c38,#c02c38,#c02c38);
    .city {
      display: flex;
      line-height: 24px;
      padding: 0 10px;
    }
  }
  .search {
    flex-grow: 1;
     .van-search{
      //background: linear-gradient(to right,#CBC9CC,#CBC9CC,#CBC9CC);
      background: linear-gradient(to right,#1baeae,#1baeae,#1baeae);
      //background: linear-gradient(to right,#c02c38,#c02c38,#c02c38);
     }
  }
}
</style>